import React, { useEffect } from "react";

const JobOpenings = ({}) => {
  useEffect(() => {
    const script = document.createElement("script");
    script.src = "https://boards.greenhouse.io/embed/job_board/js?for=lacework";
    script.async = true;
    script.onload = function () {
      let autoLoad = window?.Grnhse?.Iframe?.autoLoad;
      if (autoLoad) {
        autoLoad();
      }
    };
    document.body.appendChild(script);
    return () => {
      document.body.removeChild(script);
    };
  }, []);
  return <div id="grnhse_app"></div>;
};

export default JobOpenings;
